// extracted by mini-css-extract-plugin
module.exports = {"c-carousel-icon-buttons":"carousel-navigation-buttons_c-carousel-icon-buttons__xLpy5","c-carousel-nav-button-left":"carousel-navigation-buttons_c-carousel-nav-button-left__mtvKp"};